// eslint-disable-next-line
import React, { ImgHTMLAttributes, memo, useCallback, useContext, useState } from 'react';
import { CircularProgress, IconButton, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Refresh } from '@material-ui/icons';
import MessagesContext from '../../../contexts/messagesContext';

const useStyles = makeStyles({
    imgContainer: {
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loading: ({ status }) => ({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: 'white',
        display: status.loading ? 'flex' : 'none',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity 0.5s ease'
    }),
    img: {}
});

/**
 *
 * @param {ImgHTMLAttributes & {minWidth: string | number,minHeight: string | number}} props
 */
function Image({ src, alt = '', ...props }) {
    const { messages } = useContext(MessagesContext);
    const [status, setStatus] = useState({ loading: true, error: false });
    const classes = useStyles({ status });

    const className = `${classes.imgContainer} ${props.className}`;

    const handleLoading = useCallback(() => {
        setStatus((state) => ({ ...state, loading: true }));
    }, []);

    const handleLoadEnd = useCallback(() => {
        setStatus((state) => ({ ...state, loading: false }));
    }, []);

    const handelError = useCallback(() => {
        const timeout = setTimeout(() => {
            setStatus((state) => ({ ...state, error: !state.error, loading: !state.error }));
            clearTimeout(timeout);
        }, 200);
    }, []);

    const handleRefresh = useCallback(() => {
        setStatus((state) => ({ ...state, error: false, loading: true }));
    }, []);

    if (status.error) {
        return (
            <div className={className}>
                <IconButton onClick={handleRefresh} size="medium">
                    <Refresh />
                </IconButton>
                <Typography>{messages.alerts.error}</Typography>
            </div>
        );
    }

    return (
        <div className={className}>
            <div className={classes.loading}>
                <CircularProgress color="primary" />
            </div>
            {/* eslint-disable react/no-unknown-property */}
            <img
                {...props}
                src={src}
                onError={handelError}
                onLoadStart={handleLoading}
                onLoad={handleLoadEnd}
                alt={alt}
                className={`${classes.img} ${props.className}`}
            />
        </div>
    );
}

Image.propTypes = {
    src: PropTypes.any,
    className: PropTypes.any,
    minWidth: PropTypes.any,
    minHeight: PropTypes.any,
    alt: PropTypes.string.isRequired
};

export default memo(Image);
